import React from 'react';

import {DefaultAppFooter} from 'src/components/default-footer.component';

import Group, {Item} from '@pb/kit-component-group';
import {PageHeader, PageLogo, PageMain} from '@pb/kit-component-page-v2';
import Typography from '@pb/kit-component-typography';

import {mainContent, mainHeader} from '../main/main.module.styl';

export const UnauthorizedPage: React.FC = () => {
    return (
        <>
            <PageMain className={mainContent}>
                <PageHeader>
                    <Item grow={1}>
                        <Group direction="h" justify="space-between" className={mainHeader} alignItems="center">
                            <PageLogo/>
                        </Group>
                    </Item>
                </PageHeader>
                <Group direction="v" gap="xl" alignItems="center" justify="center" style={{minHeight: '80vh'}}>
                    <Typography
                        style={{borderBottom: '2px solid #eee', paddingBottom: 12}}
                        variant="heading-level-1">
                        Unauthorized
                    </Typography>
                    <p>
                        Your account does not have access to this application.
                        If you believe this is a mistake, please contact support.
                    </p>
                </Group>
            </PageMain>
            <DefaultAppFooter/>
        </>
    );
};
